import { render, staticRenderFns } from "./SubjectTemplateItem.vue?vue&type=template&id=4c70095c&scoped=true&"
import script from "./SubjectTemplateItem.vue?vue&type=script&lang=js&"
export * from "./SubjectTemplateItem.vue?vue&type=script&lang=js&"
import style0 from "./SubjectTemplateItem.vue?vue&type=style&index=0&id=4c70095c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c70095c",
  null
  
)

export default component.exports